// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"7406986d","118":"d562d839","250":"194d388a","787":"73f047a7","842":"9c99e26e","920":"2303bb80","943":"5d8c9fba"}[chunkId] + ".chunk.js";
};